module.exports = __webpack_public_path__ + "static/media/galleryImg12.3475e8b2.jpg";